<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <PICK_scondHero />
        <PICK_highLights :clientWidth="clientWidth"/>
        <PICK_twoTout />

        <div>Distributor</div>


    </main>

</template>


<script>
    import PICK_scondHero from "../../components/content/member/overView/PICK_scondHero";
    import PICK_highLights from "../../components/content/member/overView/PICK_highLights";
    import PICK_twoTout from "../../components/content/member/overView/PICK_twoTout";


    export default {
        name: 'SelfPickUp',
        components: {
            PICK_scondHero,
            PICK_highLights,
            PICK_twoTout,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
